module.exports.set = function(key, value, exdays) {
    var d = new Date();
    d.setTime(d.getTime()+(exdays*24*60*60*1000));
    var expires = "expires="+d.toGMTString();

    var domain;

    try {
        var str = window.location.href;
        var match = str.match(/(?:https?:\/\/)?(?:www\.)?(.*?)\//);
        var domain = '.' + match[match.length-1];
    } catch(err) {
        // do nothing
    }

    var cookie = key + "=" + value + "; " + expires + "; path=/";
    cookie += (typeof domain != 'undefined') ? "; domain=" + domain : '';

    document.cookie = cookie;
}

module.exports.get = function(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');

    for(var i=0; i<ca.length; i++) {
      var c = ca[i].trim();
        if (c.indexOf(name) === 0) {
          return c.substring(name.length,c.length);
        }
    }
};

module.exports.delete = function(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
